
export class AppSettings {
    public static ACCESS_TOKEN: string = 'app_access_token';
    public static AUTH_USER: string = 'app_current_user';
    public static ON_STRIPE_CHECKOUT_SUCCESS: string = 'ON_STRIPE_CHECKOUT_SUCCESS';
    public static ON_SQUAREPOST_CHECKOUT_SUCCESS: string = 'ON_SQUAREPOS_CHECKOUT_SUCCESS';
    public static ON_SHOPIFY_CHECKOUT_SUCCESS: string = 'ON_SHOPIFY_CHECKOUT_SUCCESS';
    public static APP_LANG: string = 'app_lang';
    public static REMEMBERED_USERNAME: string = 'app_remembered_username';
    /** Prefix for per-grid artwork card-size preference, e.g. 'artworkCardSize:gallery-inventory'. */
    public static ARTWORK_CARD_SIZE_PREFIX: string = 'artworkCardSize:';
}